module.exports = __webpack_public_path__ + "img/logo-useb.4d6724a1.svg";